jQuery(document).ready(function($) {
    let isLoading = false;
    let observer = null;
    let debounceTimer = null;
    let isBackButtonNavigation = false;
    let maxLoadedCount = 0; // Track the maximum number of products loaded

    // Add loading overlay to the DOM
    $('body').append(`
        <div class="products-loading-overlay" style="display: none;">
            <div class="products-loading-spinner"></div>
            <div class="products-loading-text">Loading products...</div>
        </div>
    `);

    // Add styles for the loading overlay
    const styles = `
        .products-loading-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.8);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 9999;
        }
        .products-loading-spinner {
            width: 50px;
            height: 50px;
            border: 5px solid #f3f3f3;
            border-top: 5px solid rgb(0, 0, 0);
            border-radius: 50%;
            animation: products-spin 1s linear infinite;
            margin-bottom: 15px;
        }
        .products-loading-text {
            font-size: 18px;
            color: #333;
        }
        @keyframes products-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;
    $('<style>').text(styles).appendTo('head');

    // Function to show/hide loading overlay
    function toggleLoader(show) {
        $('.products-loading-overlay')[show ? 'fadeIn' : 'fadeOut'](300);
    }

    // Function to detect back navigation
    function isBackNavigation() {
        // Check if browser supports Navigation Timing API v2
        if (window.performance && window.performance.getEntriesByType) {
            const navEntries = performance.getEntriesByType('navigation');
            if (navEntries.length > 0) {
                return navEntries[0].type === 'back_forward';
            }
        }
        
        // Fallback to older Navigation Timing API
        if (window.performance && window.performance.navigation) {
            return window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD;
        }

        return false;
    }

    // Store the target ID when clicking anywhere on the search result card
    $(document).on('click', '.search-result', function(e) {
        const targetId = $(this).data('id');
        
        if (targetId) {
            sessionStorage.setItem('scrollTargetId', targetId);
            sessionStorage.setItem('scrollSourceUrl', window.location.pathname);
            sessionStorage.setItem('scrollTimestamp', Date.now());
        }
    });

    // Function to check if we're navigating back to search page
    function isNavigatingBackToSearch() {
        const sourceUrl = sessionStorage.getItem('scrollSourceUrl');
        const targetId = sessionStorage.getItem('scrollTargetId');
        const timestamp = sessionStorage.getItem('scrollTimestamp');
        const currentPath = window.location.pathname;
        const isSearchPage = currentPath.includes('/products/') || currentPath.includes('/product-search');
        const isBackButton = isBackNavigation();
        
        // Consider it a back navigation if:
        // 1. We have a stored target ID and source URL
        // 2. We're on the search/products page
        // 3. The timestamp is within the last 5 minutes (to prevent stale data)
        // 4. This was triggered by back button
        const isRecentNavigation = timestamp ? (Date.now() - parseInt(timestamp)) < 300000 : false; // 5 minutes

        return sourceUrl && targetId && isSearchPage && isRecentNavigation && isBackButton;
    }

    // Function to cleanup storage
    function cleanupStorage() {
        sessionStorage.removeItem('scrollTargetId');
        sessionStorage.removeItem('scrollSourceUrl');
        sessionStorage.removeItem('scrollTimestamp');
        // Reset maxLoadedCount when cleaning up storage
        maxLoadedCount = 0;
    }

    // Function to check if element exists and scroll to it
    function scrollToTarget() {
        const targetId = sessionStorage.getItem('scrollTargetId');
        
        if (!targetId) {
            return false;
        }

        const targetElement = document.querySelector(`.search-result[data-id="${targetId}"]`);
        
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            
            // Update the global current_product_count to match our position
            const productsArray = safeJSONParse($('.productsearch__wrapper').data('posts-array'));
            if (productsArray && Array.isArray(productsArray)) {
                const targetIndex = productsArray.findIndex(id => id === parseInt(targetId));
                if (targetIndex !== -1) {
                    // Round up to the nearest multiple of 12 to match the batch size
                    window.current_product_count = Math.ceil((targetIndex + 1) / 10) * 10;
                    // Update data attribute to maintain consistency
                    $('.productsearch__wrapper').data('current-count', window.current_product_count);
                }
            }
            
            cleanupStorage();
            isLoading = false;
            toggleLoader(false);
            cleanupObserver();
            return true;
        }
        return false;
    }

    // Function to safely parse JSON with error handling
    function safeJSONParse(data) {
        try {
            if (Array.isArray(data)) return data;
            return JSON.parse(data);
        } catch (e) {
            return [];
        }
    }

    // Function to cleanup observer
    function cleanupObserver() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    // Function to load more products until target is found
    function loadMoreProductsUntilTargetFound() {
        if (isLoading) {
            return;
        }

        const targetId = sessionStorage.getItem('scrollTargetId');
        if (!targetId) {
            isLoading = false;
            toggleLoader(false);
            cleanupObserver();
            return;
        }

        const $wrapper = $('.productsearch__wrapper');
        if (!$wrapper.length) {
            isLoading = false;
            toggleLoader(false);
            cleanupObserver();
            return;
        }

        const rawProductsArray = $wrapper.data('posts-array');
        const productsArray = safeJSONParse(rawProductsArray);
        const currentCount = window.current_product_count || parseInt($wrapper.data('current-count') || 10);
        
        if (!Array.isArray(productsArray) || productsArray.length === 0) {
            isLoading = false;
            toggleLoader(false);
            cleanupObserver();
            return;
        }

        if (currentCount >= productsArray.length) {
            isLoading = false;
            toggleLoader(false);
            cleanupObserver();
            return;
        }

        isLoading = true;
        toggleLoader(true);
        
        const nextProductIds = productsArray.slice(currentCount, currentCount + 10);
        const adType = Math.floor(currentCount / 10) % 2 === 0 ? 9 : 11;

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'get_next_12_products',
                nextProductIds: nextProductIds,
                ad_type: adType
            },
            success: function(response) {
                let responseObj;
                try {
                    responseObj = JSON.parse(response);
                } catch (e) {
                    isLoading = false;
                    toggleLoader(false);
                    cleanupObserver();
                    return;
                }

                window.current_product_count = currentCount + 12;
                $('.productsearch__wrapper').data('current-count', window.current_product_count);
                
                $('.productsearch__wrapper').append(responseObj.response);

                // Check if the target is in this batch
                const targetInBatch = nextProductIds.includes(parseInt(targetId));

                // Try to scroll to target after new content is loaded
                if (!scrollToTarget()) {
                    if (targetInBatch) {
                        setTimeout(() => {
                            if (!scrollToTarget()) {
                                isLoading = false;
                                setTimeout(loadMoreProductsUntilTargetFound, 100);
                            }
                        }, 500);
                    } else {
                        isLoading = false;
                        setTimeout(loadMoreProductsUntilTargetFound, 100);
                    }
                }
            },
            error: function(xhr, status, error) {
                isLoading = false;
                toggleLoader(false);
                cleanupObserver();
            }
        });
    }

    // Check if we should start the loading process
    const shouldStartLoading = isNavigatingBackToSearch();
    
    if (shouldStartLoading) {
        if (!scrollToTarget()) {
            loadMoreProductsUntilTargetFound();

            // Create an observer to watch for dynamically loaded content
            observer = new MutationObserver(function(mutations) {
                if (debounceTimer) {
                    clearTimeout(debounceTimer);
                }
                
                debounceTimer = setTimeout(() => {
                    const shouldContinue = isNavigatingBackToSearch();
                    
                    if (!isLoading && shouldContinue) {
                        if (!scrollToTarget()) {
                            loadMoreProductsUntilTargetFound();
                        }
                    }
                }, 250);
            });

            // Start observing the document body for changes
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    } else {
        // Only cleanup if we're on the products page but not doing a restoration
        if (window.location.pathname.includes('/products/') || 
            window.location.pathname.includes('/product-search')) {
            cleanupStorage();
        }
    }
});
